import styled from "styled-components";

const EconomyViewContainer = styled.div`
    display: flex;
    flex-direction: column;
    
`

export default EconomyViewContainer;